import * as routeParams from './routeParams';

export const ACTIVATION = '/activation';
export const AGE_GATE = '/age';
export const AGE_VERIFICATION_FAILED = '/age-verification-failed';
export const APP_INTRO = '/intro';
export const IMPORTANT = '/important';
export const BENEFIT_PAGE = '/benefit';
export const BROWSER_VERIFICATION = '/browser-verification';
export const CLEAN_TUTORIAL = '/clean-tutorial';
export const CONNECTION_GUIDE = '/connection-guide';
export const CONNECTION_GUIDE_PARAMETRIZED = `${CONNECTION_GUIDE}/:${routeParams.DEVICE_TYPE}?/:${routeParams.BLE_CONNECTION_TYPE}?`;
export const CONNECTION_SELECTION = '/connection-selection';
export const CONNECTION_SELECTION_PARAMETERIZED = `${CONNECTION_SELECTION}/:${routeParams.DEVICE_TYPE}?/:${routeParams.BLE_CONNECTION_TYPE}?`;
export const ERROR_PAGE = '/error';
export const LEGAL_DISCLAIMER = '/legal-disclaimer';
export const LOGIN = '/login';
export const MY_DEVICES = '/my-devices';
export const NO_DEVICES = '/no-devices';
export const HOME_PAGE = '/home';
export const NOT_COMPATIBLE_BROWSER = '/not-compatible-browser';
export const PAIRING_ALERT = '/pair-alert';
export const PAIRING_ALERT_PARAMETERIZED = `${PAIRING_ALERT}/:${routeParams.DEVICE_TYPE}/:${routeParams.BLE_CONNECTION_TYPE}?`;
export const PAIRING_GUIDE = '/pair';
export const PAIRING_GUIDE_PARAMETERIZED = `${PAIRING_GUIDE}/:${routeParams.DEVICE_TYPE}/:${routeParams.BLE_CONNECTION_TYPE}?`;
export const PAIRING_SUCCESS = '/pair-success';
export const QUICK_START_GUIDE = '/quick-start-guide';
export const QUICK_START_GUIDE_PARAMETERIZED = `${QUICK_START_GUIDE}/:${routeParams.DEVICE_TYPE}?`;
export const REGISTRATION = '/registration';
export const ROOT = '/';
export const SELECT_DEVICE = '/select-device';
export const SELECT_MARKET = '/select-market';
export const SYNC = '/sync';
export const TIPS_AND_TRICKS = '/tips';
export const TIPS_AND_TUTORIALS = '/tips-and-tutorials';
export const TIPS_AND_TUTORIALS_PARAMETERIZED = `${TIPS_AND_TUTORIALS}/:${routeParams.DEVICE_TYPE}?`;
export const TNC = '/tnc';
export const TNC_DATA_COLLECTION = `${TNC}/data-collection`;
export const TNC_DATA_PREFERENCE = `${TNC}/preference-center`;
export const TNC_TERMS_OF_USE = `${TNC}/terms-of-use`;
export const TUTORIAL_LIST = '/tutorials';
export const UP_TO_DATE = '/up-to-date';
export const UP_TO_DATE_FAILED = '/up-to-date-failed';
export const UP_TO_DATE_PARAMETERIZED = `${UP_TO_DATE}/:${routeParams.SUCCESS_FWU_COUNT}`;
export const UPDATE = '/update';
export const UPDATE_CHECKING = '/update-check';
export const UPDATE_SUMMARY = '/summary-update';
export const WELCOME_PWA_PAGE = '/welcome-pwa-page';
export const WELCOME_USER = '/welcome';
export const WILDCARD = '*';

/* ------------ Device Settings -------- */
export const DEVICE_SETTINGS = '/device-settings';
export const ABOUT_DEVICE = `${DEVICE_SETTINGS}/about-device`;
export const ADVANCED_DIAGNOSTIC = `${DEVICE_SETTINGS}/advanced-diagnostic`;
export const AEM_FLEX_BATTERY = `${DEVICE_SETTINGS}/aem-flex-battery`;
export const AEM_PAUSE_MODE = `${DEVICE_SETTINGS}/aem-pause-mode`;
export const FLEX_PUFF = `${DEVICE_SETTINGS}/flex-puff`;
export const AUTO_START_MODE = `${DEVICE_SETTINGS}/auto-start-mode`;
export const CLEANING_MODE = `${DEVICE_SETTINGS}/cleaning-mode`;
export const CONNECT_CARE = `${DEVICE_SETTINGS}/connect-care`;
export const DEVICE_RENAME = `${DEVICE_SETTINGS}/device-rename`;
export const GESTURE_MODE = `${DEVICE_SETTINGS}/gesture-mode`;
export const GET_FEATURE_SECTION = `${DEVICE_SETTINGS}/get-feature-section`;
export const GET_FEATURE_SECTION_PARAMETERIZED = `${GET_FEATURE_SECTION}/:${routeParams.GET_FEATURE_TYPE}?`;
export const LED_MODE = `${DEVICE_SETTINGS}/led-mode`;
export const EXTENDED_LED_MODE = `${DEVICE_SETTINGS}/extended-led-mode`;
export const LOCATE_DEVICE = `${DEVICE_SETTINGS}/locate-device`;
export const TNC_DATA_PREFERENCE_SETTINGS = `/device-settings/preference-center-settings`;
export const RESPONSIVE_DRAW_MODE = `${DEVICE_SETTINGS}/responsive-draw-mode`;
export const RESTART_MY_DEVICE = `${DEVICE_SETTINGS}/restart-my-device`;
export const RESET_DEVICE = `${DEVICE_SETTINGS}/reset-device`;
export const UPDATE_AVAILABLE = `${DEVICE_SETTINGS}/update-available`;
export const USAGE_STATS = `${DEVICE_SETTINGS}/usage-stats`;
export const VAPE_CLOUD_SIZE_MODE = `${DEVICE_SETTINGS}/vape-cloud-size-mode`;
export const VAPE_SESSION_MODE = `${DEVICE_SETTINGS}/vape-session-mode`;
export const VIBRATION_MODE = `${DEVICE_SETTINGS}/vibration-mode`;
